<script>
export let team_instance;

export let pants_sizes;
export let jacket_sizes;

export let tracksuits_form_deadline;

export let index;



import { auth } from 'store/index.js';
import { get } from 'svelte/store';


import { onMount } from 'svelte';
import tippy from 'sveltejs-tippy';
import dayjs from 'dayjs';


import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();


let saving = false;
let changes_to_be_saved = false;


let now = dayjs();
const overdue = (dayjs().isAfter(dayjs(tracksuits_form_deadline)));


console.log(tracksuits_form_deadline);
console.log(overdue);


const team_instance_id = team_instance.id;



let pants_size;
let jacket_size;
let coach_full_name;

if (index === 1) {
	pants_size = team_instance.tracksuit_1_pants_size;
	jacket_size = team_instance.tracksuit_1_jacket_size;
	coach_full_name = team_instance.tracksuit_1_coach_name;
} else if (index === 2) {
	pants_size = team_instance.tracksuit_2_pants_size;
	jacket_size = team_instance.tracksuit_2_jacket_size;
	coach_full_name = team_instance.tracksuit_2_coach_name;
} else if (index === 3) {
	pants_size = team_instance.tracksuit_3_pants_size;
	jacket_size = team_instance.tracksuit_3_jacket_size;
	coach_full_name = team_instance.tracksuit_3_coach_name;
} else if (index === 4) {
	pants_size = team_instance.tracksuit_4_pants_size;
	jacket_size = team_instance.tracksuit_4_jacket_size;
	coach_full_name = team_instance.tracksuit_4_coach_name;
} else if (index === 5) {
	pants_size = team_instance.tracksuit_5_pants_size;
	jacket_size = team_instance.tracksuit_5_jacket_size;
	coach_full_name = team_instance.tracksuit_5_coach_name;
} else if (index === 6) {
	pants_size = team_instance.tracksuit_6_pants_size;
	jacket_size = team_instance.tracksuit_6_jacket_size;
	coach_full_name = team_instance.tracksuit_6_coach_name;
} else if (index === 7) {
	pants_size = team_instance.tracksuit_7_pants_size;
	jacket_size = team_instance.tracksuit_7_jacket_size;
	coach_full_name = team_instance.tracksuit_7_coach_name;
}



let invalid = false;

let invalid_jacket_size = false;
let invalid_pants_size = false;


let invalid_message;



let is_invalid_jacket_size;
let is_invalid_pants_size;


if (jacket_size === null) {
	jacket_size = '';
}

if (pants_size === null) {
	pants_size = '';
}

if (coach_full_name === null) {
	coach_full_name = '';
}


let initial_jacket_size = jacket_size;
let initial_pants_size = pants_size;
let initial_coach_full_name = coach_full_name;


$: {
	// ... ?
	jacket_size = formatJacketSize();
	pants_size = formatPantsSize();


	is_invalid_jacket_size = isInvalidJacketSize();
	is_invalid_pants_size = isInvalidPantsSize();


	invalid_jacket_size = (is_invalid_jacket_size);
	invalid_pants_size = (is_invalid_pants_size);


	invalid = (invalid_jacket_size || invalid_pants_size);


	changes_to_be_saved = (
		(
			(jacket_size !== initial_jacket_size) || 
			(pants_size !== initial_pants_size) ||
			(coach_full_name !== initial_coach_full_name)
		) && 
		!invalid
	);

}


const api_url = app_.env.API_URL;

const token = get(auth).token;


const save_tracksuit_disabled_props = {
	content: 'Make valid changes to tracksuit form in order to save!',
	placement: 'bottom',
	arrow: false,
};


const save_tracksuit_active_props = {
	content: 'Make valid changes to tracksuit form in order to save!',
	placement: 'bottom',
	arrow: false,
};




function formatJacketSize() {
	return jacket_size;
}


function formatPantsSize() {
	return pants_size;
}




function saveTracksuitInfo() {

	saving = true;


	let jacket_size_data = jacket_size;
	if (jacket_size === '') {
		jacket_size_data = null;
	}

	let pants_size_data = pants_size;
	if (pants_size === '') {
		pants_size_data = null;
	}

	let coach_name_data = coach_full_name;
	if (coach_full_name === '') {
		coach_name_data = null;
	}


	let body_data = JSON.stringify({
		[`tracksuit_${index}_jacket_size`]: jacket_size_data,
		[`tracksuit_${index}_pants_size`]: pants_size_data,
		[`tracksuit_${index}_coach_name`]: coach_name_data,
	});

	submitTracksuitInfo(body_data).then(data => {

		if (data[`tracksuit_${index}_jacket_size`] === null) {
			initial_jacket_size = '';
		} else {
			initial_jacket_size = data[`tracksuit_${index}_jacket_size`];
		}

		if (data[`tracksuit_${index}_pants_size`] === null) {
			initial_pants_size = '';
		} else {
			initial_pants_size = data[`tracksuit_${index}_pants_size`];
		}

		if (data[`tracksuit_${index}_coach_name`] === null) {
			initial_coach_full_name = '';
		} else {
			initial_coach_full_name = data[`tracksuit_${index}_coach_name`];
		}


		dispatch('tracksuit_saved_msg', {
			msg: `Saved tracksuit #${index} form!`,
			type: 'success',
		});

	}).catch(err => {

		dispatch('tracksuit_saved_msg', {
			msg: `Error saving tracksuit #${index} form!`,
			type: 'error',
		});

	}).finally(() => {

		saving = false;

	});

}



async function submitTracksuitInfo(body_data) {

	const url = `${api_url}coaches/team-instance/${team_instance_id}/tracksuits`;

	const resp = await fetch(url, {
		method: 'PUT',
		body: body_data,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}



function isInvalidJacketSize() {
	if (jacket_size === '') return false;
	return (!(jacket_sizes.map(item => item.size_value)).includes(jacket_size));
}


function isInvalidPantsSize() {
	if (pants_size === '') return false;
	return (!(pants_sizes.map(item => item.size_value)).includes(pants_size));
}



</script>


<style>

.tracksuit-thumb {

}

.input {
	height: 2rem;
}

span.icon {
	height: 2rem;
	width: 2rem;
	color: #d65050 !important;
}

.invalid .input {
	border-color: #c71e1e !important;
	color: #d65050 !important;
}

select.invalid {
	border-color: #c71e1e !important;
	color: #d65050 !important;
}


.invalid .tippy-tooltip {
	display: block;
}

.select {
	height: 2rem;
}

.select select {
	height: 2rem;
	padding-top: calc(0.25rem - 1px);
    padding-bottom: calc(0.25rem - 1px);
}


.message-text {
	color: #5a5a5a;
}


@media (max-width: 1024px) {
	.control.has-icons-right .input {
		padding-right: 0rem;
	}
}


</style>



<div class="panel-block tracksuit-thumb">

	<div class="columns is-variable is-mobile is-2 is-vcentered">


		<div class="column is-2">
			<span>
				Tracksuit #{index}
			</span>
		</div>


		<div class="column is-2">

			<div class="field">

				<div class="control">


					<div class="select jacket-size">
						<select bind:value={jacket_size} disabled={saving | overdue} class:invalid={invalid_jacket_size}>
							<option value="">Size</option>
							{#each jacket_sizes as size}
								<option value="{size.size_value}">{size.size_name}</option>
							{/each}
						</select>
					</div>

				</div>

			</div>

		</div>


		<div class="column is-2">

			<div class="field">

				<div class="control">


					<div class="select jacket-size">
						<select bind:value={pants_size} disabled={saving | overdue} class:invalid={invalid_pants_size}>
							<option value="">Size</option>
							{#each pants_sizes as size}
								<option value="{size.size_value}">{size.size_name}</option>
							{/each}
						</select>
					</div>


				</div>

			</div>

		</div>


		<div class="column is-3">

			<div class="field">

				<div class="control has-icons-right">

					<input class="input coach-full-name" type="text" placeholder="Coach Name" maxlength="30" bind:value={coach_full_name}>

				</div>

			</div>

		</div>


		<div class="column is-3">
			<div class="columns is-mobile is-0 is-variable is-vcentered">
				<div class="column">

				</div>
				<div class="column is-narrow">

					{#if !changes_to_be_saved | saving}

					<span use:tippy={save_tracksuit_disabled_props}>
						<span class="button is-blue is-small" disabled>
							{#if !saving}<span class="is-hidden-mobile">Save Changes</span><span class="is-hidden-desktop is-hidden-tablet">Save</span>{:else}Saving{/if}
							<i class="fas fa-circle-notch fa-spin" class:is-hidden={!saving}></i>
						</span>
					</span>

					{:else}

					<span use:tippy={save_tracksuit_active_props}>
						<span class="button is-blue is-small" type="submit" on:click={saveTracksuitInfo}>
							<span class="is-hidden-mobile">Save Changes</span><span class="is-hidden-desktop is-hidden-tablet">Save</span>
						</span>
					</span>

					{/if}

				</div>

			</div>

		</div>


	</div>

</div>






